type NoArchivdedProjectMessageProps = {
  isVisible: boolean
}

export const NoArchivedProjectsMessage = ({
  isVisible,
}: NoArchivdedProjectMessageProps) => {
  if (!isVisible) {
    return null
  }

  return (
    <div className="flex items-center justify-center h-[250px]">
      <p className="text-base font-normal text-grey-700 ">
        Nenhum projeto arquivado
      </p>
    </div>
  )
}
